<app-dialog [title]="title" [actions]="[{ text: 'Cancel', buttonStyle: 'underline' },{
  text: 'Save',
  isDisabled: form.valid ? false : true
}]" (action)="action($event)" (close)="close()">
  <div class="form" [formGroup]="form">
    <div class="input-container">
      <label class="input-container_label">Season name</label>
      <input type="text" formControlName="seasonName" class="input-container_input">
    </div>
    <div class="input-container">
      <label class="input-container_label">Start date</label>
      <mat-form-field appearance="fill" class="mat-select-control" [ngClass]="{'error': form.controls['startDate'].touched && form.controls['startDate'].errors}">
        <input matInput [matDatepicker]="startDate" formControlName="startDate" (click)="startDate.open()" [max]="form.get('endDate').value" autocomplete="off">
        <mat-datepicker-toggle matSuffix [for]="startDate"></mat-datepicker-toggle>
        <mat-datepicker #startDate [calendarHeaderComponent]="customDateHeader"> </mat-datepicker>
      </mat-form-field>
    </div>

    <div class="input-container">
      <label class="input-container_label">End date</label>
      <mat-form-field appearance="fill" class="mat-select-control" [ngClass]="{'error': form.controls['endDate'].touched && form.controls['endDate'].errors}">
        <input matInput [matDatepicker]="endDate" formControlName="endDate" (click)="endDate.open()" [min]="form.get('startDate').value" autocomplete="off"/>
        <mat-datepicker-toggle matSuffix [for]="endDate"></mat-datepicker-toggle>
        <mat-datepicker #endDate [calendarHeaderComponent]="customDateHeader"></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="input-container">
      <div class="input-container_label">
        Percentage Change
      </div>
      <div class="input-container_wrapper">
        <input type="number" class="input-container_input input-container_input--number" formControlName="percentageChange"/>
        <span class="input-container_icon">
          <i class="fa fa-percent"></i>
        </span>
      </div>
    </div>
  </div>
  <div class="summary" *ngIf="days > 0">
    <div class="summary_label">
      Summary
    </div>
    <div class="summary_info">
      <span>{{days | number: "1.0-0"}} days,</span>
      <span *ngIf="form.get('percentageChange').value">
        {{ form.get('percentageChange').value + '%' }}
      </span>
    </div>
  </div>
</app-dialog>
